export default __webpack_public_path__ + "static/media/recu6.6ccb9e06.png";